import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Col, Row, Table, UncontrolledTooltip } from 'reactstrap';

import Pagination from '../Pagination';

import './styles.css';

function CustomTable({
  columns = [],
  data = [],
  page = 1,
  limit = 10,
  totalDocs = 0,
  totalPages = 0,
  loading = false,
  hasPrevPage = false,
  hasNextPage = false,
  paging = true,
  footer: Footer,
  onChangePage = () => null,
  onRowClick = () => null,
}) {
  const colSpanSafe = Math.max(columns.length, 1);

  if (loading) {
    return (
      <Table responsive className="custom-table">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th
                key={`${column.dataField}-${index}`}
                style={{
                  verticalAlign: 'top',
                }}
              >
                <UncontrolledTooltip target={`#column-${column.id || column?.dataField?.replace(/./g, '-')}-${index}`} fade>
                  {column.text}
                </UncontrolledTooltip>
                <div id={`column-${column.id || column?.dataField?.replace(/./g, '-')}-${index}`} className="p-1 text-truncate">
                  {column.text}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 10 }).map((_, index) => (
            <tr key={index}>
              {columns.map((column) => (
                <td key={`${column.dataField}-${index}`} className="p-2">
                  <Skeleton height={20} width="100%" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  return (
    <Table responsive className="custom-table">
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              key={`${column.dataField}-${index}`}
              style={{
                verticalAlign: 'top',
                width: column.width || 'auto',
                minWidth: column.minWidth || 'auto',
                maxWidth: column.maxWidth || 'none',
                whiteSpace: column.nowrap === false ? 'normal' : 'nowrap',
              }}
            >
              <UncontrolledTooltip target={`#column-${column.id || column?.dataField?.replace(/./g, '-')}-${index}`} fade>
                {column.text}
              </UncontrolledTooltip>
              <div id={`column-${column.id || column?.dataField?.replace(/./g, '-')}-${index}`} className="p-1 text-truncate">
                {column.text}
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={`${row._id}-${index}`} onClick={() => onRowClick(row)}>
            {columns.map((column) => (
              <td
                key={column.dataField}
                className="p-2"
                style={{
                  width: column.width || 'auto',
                  minWidth: column.minWidth || 'auto',
                  maxWidth: column.maxWidth || 'none',
                  whiteSpace: column.nowrap === false ? 'normal' : 'nowrap',
                  overflow: column.ellipsis ? 'hidden' : 'visible',
                  textOverflow: column.ellipsis ? 'ellipsis' : 'clip',
                }}
                title={typeof row[column.dataField] === 'string' ? row[column.dataField] : undefined}
              >
                {column.formatter ? column.formatter(row) : row[column.dataField]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
      {paging && (
        <tfoot>
          <tr>
            <td colSpan={colSpanSafe}>
              <Row>
                <Col xs={12} tag="div" className="d-flex flex-wrap justify-content-center align-items-center justify-content-sm-end h-100">
                  <div className="text-right mr-2 mb-2">
                    {`Total de documento(s) ${page * limit > totalDocs ? totalDocs : page * limit}/${totalDocs}`}
                  </div>
                  <Pagination
                    page={page}
                    hasNextPage={hasNextPage}
                    hasPrevPage={hasPrevPage}
                    totalPages={totalPages}
                    onPageChange={onChangePage}
                  />
                </Col>
              </Row>
            </td>
          </tr>
        </tfoot>
      )}
      {Footer && <Footer />}
    </Table>
  );
}

export default CustomTable;
